'use client'

import { X } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { PopoverContent } from '@/components/ui/popover'

import { TEXT_COLORS } from './editor-color-picker.config'
import { EditorColorSwatch } from './editor-color-swatch.atom'

export interface EditorColorPickerContentProps {
  currentColor?: string
  onColorSelect: (color: string) => void
}

/**
 * Content panel for the color picker popover with color grid and clear button
 */
export const EditorColorPickerContent = ({
  currentColor,
  onColorSelect,
}: EditorColorPickerContentProps) => (
  <PopoverContent className="w-64 p-3" align="start">
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="font-medium text-sm">Text Color</span>
        {currentColor && (
          <Button
            variant="ghost"
            size="sm"
            className="h-6 px-2 text-muted-foreground text-xs"
            onClick={() => onColorSelect('')}
          >
            <X className="mr-1 size-3" />
            Clear
          </Button>
        )}
      </div>

      <div className="grid grid-cols-6 gap-1">
        {TEXT_COLORS.map((color) => (
          <EditorColorSwatch
            key={color.name}
            color={color}
            isCurrentColor={currentColor === color.value}
            onSelect={onColorSelect}
          />
        ))}
      </div>
    </div>
  </PopoverContent>
)

EditorColorPickerContent.displayName = 'EditorColorPickerContent'
